import React, { useState, useEffect } from 'react';
import { experienceAPI } from '../../services/api';

const AdminExperience = () => {
  const [experience, setExperience] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingExp, setEditingExp] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    company: '',
    location: '',
    start_date: '',
    end_date: '',
    is_current: false,
    description: [''],
  });

  useEffect(() => {
    loadExperience();
  }, []);

  const loadExperience = async () => {
    try {
      const response = await experienceAPI.getAll();
      setExperience(response.data);
    } catch (error) {
      console.error('Error loading experience:', error);
    }
  };

  const handleAdd = () => {
    setEditingExp(null);
    setFormData({
      title: '',
      company: '',
      location: '',
      start_date: '',
      end_date: '',
      is_current: false,
      description: [''],
    });
    setShowModal(true);
  };

  const handleEdit = (exp) => {
    setEditingExp(exp);
    setFormData({
      title: exp.title,
      company: exp.company,
      location: exp.location || '',
      start_date: exp.start_date ? exp.start_date.split('T')[0] : '',
      end_date: exp.end_date ? exp.end_date.split('T')[0] : '',
      is_current: exp.is_current,
      description: exp.description && exp.description.length > 0 ? exp.description : [''],
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this experience?')) return;

    try {
      await experienceAPI.delete(id);
      loadExperience();
    } catch (error) {
      console.error('Error deleting experience:', error);
      alert('Error deleting experience');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const descriptionArray = formData.description.filter(d => d.trim() !== '');
      const data = {
        title: formData.title,
        company: formData.company,
        location: formData.location,
        start_date: formData.start_date,
        end_date: formData.is_current ? null : formData.end_date,
        is_current: formData.is_current,
        description: descriptionArray,
      };

      if (editingExp) {
        await experienceAPI.update(editingExp.id, data);
      } else {
        await experienceAPI.create(data);
      }
      setShowModal(false);
      loadExperience();
    } catch (error) {
      console.error('Error saving experience:', error);
      alert('Error saving experience');
    } finally {
      setLoading(false);
    }
  };

  const addDescriptionItem = () => {
    setFormData({ ...formData, description: [...formData.description, ''] });
  };

  const updateDescriptionItem = (index, value) => {
    const newDescription = [...formData.description];
    newDescription[index] = value;
    setFormData({ ...formData, description: newDescription });
  };

  const removeDescriptionItem = (index) => {
    const newDescription = formData.description.filter((_, i) => i !== index);
    setFormData({ ...formData, description: newDescription.length > 0 ? newDescription : [''] });
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-gray-800 dark:text-gray-200 text-2xl font-bold mb-4">Work Experience</h2>
        <button className="btn btn-primary" onClick={handleAdd}>Add Experience</button>
      </div>

      <div className="item-list">
        {experience.map((exp) => (
          <div key={exp.id} className="item-card">
            <div className="item-card-content">
              <h3>{exp.title}</h3>
              <p><strong>{exp.company}</strong> {exp.location && `- ${exp.location}`}</p>
              <p>{new Date(exp.start_date).toLocaleDateString()} - {exp.is_current ? 'Present' : new Date(exp.end_date).toLocaleDateString()}</p>
            </div>
            <div className="item-card-actions">
              <button className="btn btn-secondary btn-sm" onClick={() => handleEdit(exp)}>Edit</button>
              <button className="btn btn-danger btn-sm" onClick={() => handleDelete(exp.id)}>Delete</button>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingExp ? 'Edit Experience' : 'Add Experience'}</h2>
              <button className="close-btn" onClick={() => setShowModal(false)}>&times;</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Title *</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Company *</label>
                <input
                  type="text"
                  value={formData.company}
                  onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Location</label>
                <input
                  type="text"
                  value={formData.location}
                  onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Start Date *</label>
                <input
                  type="date"
                  value={formData.start_date}
                  onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.is_current}
                    onChange={(e) => setFormData({ ...formData, is_current: e.target.checked, end_date: '' })}
                  />
                  Current Position
                </label>
              </div>
              {!formData.is_current && (
                <div className="form-group">
                  <label>End Date</label>
                  <input
                    type="date"
                    value={formData.end_date}
                    onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
                  />
                </div>
              )}
              <div className="form-group">
                <label>Description</label>
                {formData.description.map((desc, index) => (
                  <div key={index} className="array-input-item">
                    <input
                      type="text"
                      value={desc}
                      onChange={(e) => updateDescriptionItem(index, e.target.value)}
                      placeholder="Enter description point"
                    />
                    {formData.description.length > 1 && (
                      <button type="button" className="btn btn-danger btn-sm" onClick={() => removeDescriptionItem(index)}>Remove</button>
                    )}
                  </div>
                ))}
                <button type="button" className="btn btn-secondary" onClick={addDescriptionItem} style={{ marginTop: '0.5rem' }}>
                  Add Description Point
                </button>
              </div>
              <div className="form-actions">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminExperience;

